import React from "react";
import {
  category1,
  category2,
  category3,
  category4,
  category5,
  seller1,
  seller2,
  seller3,
  seller4,
  seller5,
} from "../Constant/Index";
import Slider from "react-slick";

function Slidertwo() {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="insta-slider">
        <div className="insta-slider-con">
          <Slider {...settings}>
            <div className="insta-slide">
              <img src={seller1} alt="category-one" className="img-fluid" />
            </div>
            <div className="insta-slide">
              <img src={seller2} alt="category-one" className="img-fluid" />
            </div>
            <div className="insta-slide">
              <img src={seller3} alt="category-one" className="img-fluid" />
            </div>
            <div className="insta-slide">
              <img src={seller4} alt="category-one" className="img-fluid" />
            </div>
            <div className="insta-slide">
              <img src={seller5} alt="category-one" className="img-fluid" />
            </div>
          </Slider>
        </div>
      </div>
    </>
  );
}

export default Slidertwo;
